import Chai from "chai"
import App from "@frog/source/models/App.js"
import Dev from "@frog/source/models/dev/Dev.js"
import games from "@frog/source/data/games/index.js"
import savetests from "@frog/source/data/games/savetests.js"

const tests = [
    {"slug": "add", "func": () => Chai.expect(2 + 2).to.equal(4)},
    {"slug": "divide", "func": () => Chai.expect(2 / 2).to.equal(1)},
    {"slug": "multiply", "func": () => Chai.expect(2 * 3).to.equal(6)},
    {"slug": "remainder", "func": () => Chai.expect(2 % 3).to.equal(2)},
    {"slug": "subtract", "func": () => Chai.expect(2 - 3).to.equal(-1)},
    {"slug": "rightshift", "func": () => Chai.expect(2 >> 3).to.equal(0)},
    {"slug": "leftshift", "func": () => Chai.expect(2 << 3).to.equal(16)},
    {"slug": "leftshift", "func": () => Chai.expect(2 ** 3).to.equal(8)},
]

tests.push({"slug": "savetests", "func": () => Chai.expect(doSavetestsClear(savetests)).to.equal(true)})

// var context = require.context("@frog/source/tests", false, /.test.js$/)
// const tests2 = context.keys().map((key) => {
//     const tests = context(key)
//     tests = tests.concat(tests)
//     return tests
// })

// window.frog = window.frog || {}
// window.frog.tests = window.frog.tests || tests

function doSavetestsClear(tests) {
    Dev.inProtoMode = false
    Object.values(tests).forEach((test) => {
        if(test.status == undefined) {
            test.isLoading = true
            const game = games[test.gameSlug]
            const chapter = game.chapters[test.chapterSlug]
            App.load({"game": {...game, chapter}})
            test.status = Dev.replaySavestate(test) ? "good" : "bad"
            test.isLoading = false
        }
    })

    return Object.values(tests).every((test) => test.status == "good")
}

export default tests
